import React from "react";

const OffIcon = ({ size = 345, h = "10", fill = "#4361E9" }) => {
  // create the height and width based on the size prop, default width is 345 and height is 231
  const width = (size / 345) * 345;
  const height = (size / 345) * 231;
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75781 3.52832C10.3293 4.10009 10.7465 4.80742 10.9704 5.5842C11.1944 6.36098 11.2177 7.18185 11.0383 7.9701"
        stroke="#B91C1C"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.27675 3.27344C2.76913 3.69978 2.3557 4.22701 2.06272 4.82165C1.76973 5.41629 1.60358 6.06535 1.57482 6.72763C1.54605 7.38991 1.65531 8.05093 1.89564 8.66873C2.13597 9.28654 2.50213 9.84762 2.97088 10.3164C3.43962 10.7851 4.0007 11.1513 4.61851 11.3916C5.23631 11.6319 5.89733 11.7412 6.55961 11.7124C7.22189 11.6837 7.87095 11.5175 8.46559 11.2245C9.06023 10.9315 9.58746 10.5181 10.0138 10.0105"
        stroke="#B91C1C"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.375 1.0625V3.18775"
        stroke="#B91C1C"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.0625 1.0625L11.6888 11.6888"
        stroke="#B91C1C"
        stroke-width="1.06263"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default OffIcon;
